import { useState } from "react";

const Clock = () => {
  const [time, setTime] = useState(getTime());

  function two_digits(n: number): String {
    return n < 10 ? "0" + n : "" + n;
  }

  function getTime(): string {
    const d = new Date();
    const h = two_digits(d.getHours());
    const m = two_digits(d.getMinutes());
    return `${h}:${m}`;
  }

  setInterval(() => {
    setTime(getTime());
  }, 1000);

  return <span className="clock up">{time}</span>
};

export default Clock;
